import { CustomerDetails } from './customer-details.model';
import { CustomerCredit } from './customer-credit.model';

export class Customer {
    customerDetails: CustomerDetails;
    customerCredit: CustomerCredit;
}